var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.534 7.333)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.594 6.503h-.049C23.081 2.592 18.77 0 13.863 0 8.958 0 4.646 2.592 2.182 6.503h-.047C.958 6.503 0 7.47 0 8.673v3.248c0 1.196.952 2.17 2.135 2.17h28.797c.589 0 1.068-.487 1.068-1.085-.006-3.595-2.868-6.503-6.406-6.503z",
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2175D9",
    cx: 7.468,
    cy: 14.085,
    rx: 3.197,
    ry: 3.249
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2175D9",
    cx: 24.886,
    cy: 14.085,
    rx: 3.197,
    ry: 3.249
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 7.468,
    cy: 14.085,
    rx: 1.068,
    ry: 1.085
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 24.886,
    cy: 14.085,
    rx: 1.068,
    ry: 1.085
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC41MzQgNy4zMzMpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGZpbGw9Im5vbmUiPgogICAgICAgIDxwYXRoIGQ9Ik0yNS41OTQgNi41MDNoLS4wNDlDMjMuMDgxIDIuNTkyIDE4Ljc3IDAgMTMuODYzIDAgOC45NTggMCA0LjY0NiAyLjU5MiAyLjE4MiA2LjUwM2gtLjA0N0MuOTU4IDYuNTAzIDAgNy40NyAwIDguNjczdjMuMjQ4YzAgMS4xOTYuOTUyIDIuMTcgMi4xMzUgMi4xN2gyOC43OTdjLjU4OSAwIDEuMDY4LS40ODcgMS4wNjgtMS4wODUtLjAwNi0zLjU5NS0yLjg2OC02LjUwMy02LjQwNi02LjUwM3oiIGZpbGw9IiMwRjE5NDEiLz4KICAgICAgICA8ZWxsaXBzZSBmaWxsPSIjMjE3NUQ5IiBjeD0iNy40NjgiIGN5PSIxNC4wODUiIHJ4PSIzLjE5NyIgcnk9IjMuMjQ5Ii8+CiAgICAgICAgPGVsbGlwc2UgZmlsbD0iIzIxNzVEOSIgY3g9IjI0Ljg4NiIgY3k9IjE0LjA4NSIgcng9IjMuMTk3IiByeT0iMy4yNDkiLz4KICAgICAgICA8ZWxsaXBzZSBmaWxsPSIjRkZGIiBjeD0iNy40NjgiIGN5PSIxNC4wODUiIHJ4PSIxLjA2OCIgcnk9IjEuMDg1Ii8+CiAgICAgICAgPGVsbGlwc2UgZmlsbD0iI0ZGRiIgY3g9IjI0Ljg4NiIgY3k9IjE0LjA4NSIgcng9IjEuMDY4IiByeT0iMS4wODUiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgAutomobile as ReactComponent };